import {
  IAddressCreateProps,
  IAddressProps,
  IAddressUpdateProps,
} from '../AddressService/types';
import { IRecognitionGroupSimpleProps } from './Group/types';
import { IFacialControllerSimpleProps } from '../Devices/Recognition/Controllers/types';
import { ISchoolClassSimpleProps } from '../SchoolClass/types';
import { IDeviceGroupProps } from '../DeviceGroupService/types';

export enum IRecognitionTypes {
  GENERAL = 'GeneralRecognitionEntity',
  CUSTOMER = 'CustomerRecognitionEntity',
  STUDENT = 'StudentRecognitionEntity',
  RESPONSIBLE = 'ResponsibleRecognitionEntity',
}

export interface IRecognitionTypeOption {
  label: string;
  value: IRecognitionTypes;
}

export interface IRecognitionProps {
  id: number;
  name: string;
  cpf?: string;
  cnpj?: string;
  image: string;
  validUntil?: Date;
  phone: string;
  vehicleTags?: string[] | null;
  accessCardTags?: string[] | null;
  type?: string | null;
  uc?: string[] | null;
  recognitionGroups?: IRecognitionGroupSimpleProps[];
  facialControllers?: IFacialControllerSimpleProps[];
  deviceGroups?: IDeviceGroupProps[];
  classId?: number[] | null;
  address?: IAddressProps;
}

export interface IRecognitionSimpleProps {
  id?: number;
  name: string;
  isTemporary: boolean;
  isActive?: boolean;
  cpf?: string;
  cnpj?: string;
  userId?: string;
  image?: string | Blob;
  discriminator: IRecognitionTypes;
  validUntil?: Date;
  registration?: string;
  facialControllersIds?: number[];
  deviceGroupIds?: number[] | null;
  recognitionGroupIds?: number[] | null;

  phone?: string;
  vehicleTags?: string[] | null;
  accessCardTags?: string[] | null;
  type?: string | null;
  uc?: string[] | null;
}

export interface IRecognitionCreateProps {
  name: string;
  cpf?: string;
  cnpj?: string;
  validUntil?: string | null;
  phone?: string;
  vehicleTags?: string[] | null;
  accessCardTags?: string[] | null;
  recognitionGroupIds: number[] | null;
  facialControllerIds: number[] | null;
  deviceGroupIds?: number[] | null;

  address?: IAddressCreateProps | null;
  file?: Blob | string;
  type?: string | null;
  uc?: string[] | null;
}

export interface IRecognitionUpdateProps {
  name: string;
  cpf?: string;
  cnpj?: string;
  image?: string;
  validUntil?: string | null;
  phone?: string;
  vehicleTags?: string[] | null;
  accessCardTags?: string[] | null;
  recognitionGroupIds: number[] | null;
  facialControllerIds: number[] | null;
  deviceGroupIds?: number[] | null;
  address?: IAddressUpdateProps | null;
  file?: Blob | string;
  type?: string | null;
  uc?: string[] | null;
}

export interface IRecognitionFilterParams {
  search?: string;
  discriminator?: IRecognitionTypes;
  isActive?: boolean;
  temporary?: boolean;
}

export interface IRecognitionDeleteParams {
  id: number;
  type: IRecognitionTypes;
}
